module.exports = __webpack_public_path__ + "img/2A2D21_555742_898974_6C745B-256px.d954db23.png";